import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'

export interface UpdatePurchaseProcessStage {
    execute(id: string, stageId: string): Promise<PurchaseProcess>
    getSource(): string
}

export class UpdatePurchaseProcessStageUseCase
    implements UpdatePurchaseProcessStage
{
    constructor(private repository: PurchasingRepository) {}
    async execute(id: string, stageId: string): Promise<PurchaseProcess> {
        return this.repository.updateProcessStage(id, { stageId })
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
